import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@material-ui/core';

import QuizQuestionsList from './QuizQuestionsList';
import QuizSubmissionsList from './QuizSubmissionsList';

const getNavigationForQuiz = (navigation, quizId) =>
  navigation && navigation.quizId === quizId ? navigation : null;

const QuizExpandPanel = ({ record, navigation = null, course }) => {
  const initialNavigation = getNavigationForQuiz(navigation, record.id);
  const [activeView, setActiveView] = useState(() =>
    initialNavigation ? 'by_question' : 'by_students'
  );
  const [expandedQuestionIndex, setExpandedQuestionIndex] = useState(() =>
    initialNavigation ? initialNavigation.questionIndex : null
  );
  const [navigationRequestId, setNavigationRequestId] = useState(() =>
    initialNavigation ? initialNavigation.requestId : null
  );

  useEffect(() => {
    const nextNavigation = getNavigationForQuiz(navigation, record.id);
    if (!nextNavigation) return;
    setActiveView('by_question');
    setExpandedQuestionIndex(nextNavigation.questionIndex);
    setNavigationRequestId(nextNavigation.requestId);
  }, [navigation, record.id]);

  return (
    <Box>
      <Tabs
        value={activeView}
        onChange={(_, value) => setActiveView(value)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="By Students" value="by_students" />
        <Tab label="By Question" value="by_question" />
      </Tabs>
      {activeView === 'by_students' ? (
        <QuizSubmissionsList record={record} course={course} />
      ) : (
        <QuizQuestionsList
          record={record}
          expandedQuestionIndex={expandedQuestionIndex}
          navigationRequestId={navigationRequestId}
        />
      )}
    </Box>
  );
};

export default QuizExpandPanel;
